var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#00386C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6, 7)",
    d: "M15.5661 0.174997C15.8818 0.393747 16.0474 0.771872 15.988 1.15L13.988 14.15C13.9411 14.4531 13.7568 14.7187 13.488 14.8687C13.2193 15.0187 12.8974 15.0375 12.613 14.9187L8.66613 13.2781L7.413 15.6062C7.2505 15.9094 6.90363 16.0625 6.56925 15.9781C6.23488 15.8937 6.0005 15.5937 6.0005 15.25V12.25C6.0005 12.0844 6.05675 11.9219 6.15988 11.7906L11.3255 5.14687C11.4036 4.925 11.1224 4.7 10.9193 4.88437L5.3255 9.94375L4.3255 10.8469C4.038 11.1062 3.62863 11.1781 3.26925 11.0281L0.613003 9.92187C0.263003 9.77499 0.0255029 9.44374 0.00362787 9.06249C-0.0182471 8.68125 0.175503 8.32187 0.506753 8.13125L14.5068 0.131247C14.8411 -0.0593776 15.2536 -0.0406276 15.5693 0.174997H15.5661Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.9dfb5f82ad33ecb4ab5f9f873b7fbb40.svg";
export { ForwardRef as ReactComponent };